import { useState } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { SignalCall } from './components/SignalCall';
import { Features } from './components/Features';
import { Sources } from './components/Sources';
import { Footer } from './components/Footer';
import { EmailModal } from './components/EmailModal';

export default function App() {
  const [accessOpen, setAccessOpen] = useState(false);
  const open = () => setAccessOpen(true);
  const close = () => setAccessOpen(false);

  return (
    <>
      <Nav onRequestAccess={open} />
      <main>
        <Hero onRequestAccess={open} />
        <SignalCall />
        <Features />
        <Sources />

        <section className="py-24 sm:py-28">
          <div className="container-page">
            <div className="rounded-[24px] border border-border bg-bg-raised px-8 py-20 text-center">
              <h2 className="mx-auto max-w-[20ch] text-display-lg">
                See the calls Claros surfaces.
              </h2>
              <p className="mx-auto mt-4 max-w-[48ch] text-ink-muted">
                A 30-minute call: bring a company — yours or one you're
                diligencing — and we'll show you the calls it surfaces, live.
              </p>
              <div className="mt-8 flex justify-center">
                <button type="button" onClick={open} className="btn-primary">
                  Request early access
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <EmailModal open={accessOpen} onClose={close} />
    </>
  );
}
